import React from 'react'
import { IDepartment } from '.'
import { CTALink } from '../../elements/CTALink'
import { LegacyColor, CTATheme } from '../../utils'

type IProps = {
  department: IDepartment
}

const teamPages: Record<number, string> = {
  12869: '/careers-engineering',
  50960: '/careers-product-design',
  51032: '/careers-product-management',
  12871: '/careers-sales',
  73802: '/careers-research-analytics-data-science',
  33689: '/careers-finance-accounting-business-systems-strategic-planning',
  33690: '/careers-finance-accounting-business-systems-strategic-planning',
  73532: '/careers-finance-accounting-business-systems-strategic-planning',
  12870: '/careers-marketing',
  12967: '/careers-people-teams',
  12875: '/careers-people-teams',
  12876: '/careers-customer-support',
}

const TeamCTA = ({ department }: IProps) => {
  const teamUrl = teamPages[department.id]

  if (!teamUrl) return null

  return (
    <span className="team-cta">
      <CTALink
        url={teamUrl}
        text="Team Page"
        bgColor={CTATheme.WhiteOutline}
        arrow={false}
        eventContext="Careers teams page link"
        eventObjectName={department.name}
      />

      <style jsx>{`
        :global(.greenhouse-listings .cta-link) {
          background-color: ${LegacyColor.LightGray};
          border: 2px solid ${LegacyColor.LightGray};
          color: black;
          display: flex;
          line-height: 0.875rem;
          padding: 0.5rem 1.25rem;
        }

        :global(.greenhouse-listings a.cta-link span) {
          font-weight: normal;
          font-size: 0.875rem;
          white-space: nowrap;
        }

        :global(.greenhouse-listings .cta-link:hover, .greenhouse-listings .cta-link:focus) {
          background-color: ${LegacyColor.LightGray};
          border: 2px solid ${LegacyColor.LightGray};
        }
      `}</style>
    </span>
  )
}

export default TeamCTA
